import React from 'react';
import { Badge } from 'primereact/badge';
import { bdi_classe, bdi_severity, bdi_size, bdi_subclasse, bdi_alinhamento_lateral, bdi_alinhamento_vertical } from './AtributosBDI';

const BadgeBDI = props => {
    return React.createElement(Badge, { value: props.valor, className: props.className, size: props.size, severity: props.severity });
};

BadgeBDI.bdi_classe = bdi_classe;
BadgeBDI.bdi_severity = bdi_severity;
BadgeBDI.bdi_size = bdi_size;
BadgeBDI.bdi_subclasse = bdi_subclasse;
BadgeBDI.bdi_alinhamento_lateral = bdi_alinhamento_lateral;
BadgeBDI.bdi_alinhamento_vertical = bdi_alinhamento_vertical;

export default BadgeBDI;